
























































import { Component, Prop, Emit } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import CreateCampaignDialogCountryMixin from '@/views/reports/mixins/flow/create-campaign-dialog-country-mixin';
import FlowMixin from '@/views/reports/mixins/flow/flow-mixin';

import CreateCampaignDialogFlowLandingErrorsMixin from '@/views/reports/mixins/flow/create-campaign-dialog-flow-landing-errors-mixin';

import { uniq } from 'lodash';
import Vue from 'vue';

export interface FlowLandingConfirm {
  item: any;
  oldItem: any
}

@Component
export default class CreateCampaignDialogFlowLanding extends mixins(FlowMixin,CreateCampaignDialogCountryMixin, CreateCampaignDialogFlowLandingErrorsMixin) {
  oldValue=null
  
  @Prop()
  ruleIndex: number;

  @Prop()
  path: any;

  @Prop({ default: false })
  isDisabledWeight: boolean;

  @Prop() 
  pathIndex: number;

  @Prop() 
  landingIndex: number;

  @Prop()
  landing: any;

  @Prop({ default: () => [] as any[] })
  landingIds: string[];

  @Prop() 
  directLinking: boolean;

  @Prop({ default: () => [] as string[] })
  errorConditionPrefix: string[];

  @Prop({ default: 0 })
  totalWeight: number;

  @Prop() 
  dialogRepositionParam: string;

  @Emit('delete')
  onDelete() {}

  @Emit('edit')
  onEdit() {}

  @Emit('preview')
  onPreview() {}

  get errorCondition(): any[] {
    return [
      ...this.errorConditionPrefix, 
      ...this.getLandingErrorCondition(this.ruleIndex, this.pathIndex, this.landingIndex)
    ];
  }

  get otherLandings() {
    return this.landing.id 
      ? this.landingIds.filter((id) => id !== this.landing.id) 
      : this.landingIds;
  }

  get landingsListFiltered() {
    return this.$store.state.cache.landings.data
      .filter((item) => !this.otherLandings.some((otherLandingId) => otherLandingId === item.id));
  }

  get landingUrl() {
    return this.getItem(this.landing.id)?.url || '';
  }

  getItem(id: string) {
    return this.path.landings.find((item: any) => item.id === id);
  }
  
  onChange( value) {
    this.oldValue = this.landing;

    Vue.set(this.path.landings, this.landingIndex, {
      weight:this.landing.weight,
      ...value
    });
    
    if (!value) {
      return false;
    }

    if(value?.offers === 1) {
      return true;
    }

    const landings = this.$store.state.cache.landings.data
      .filter((item: any) => this.landingIds.includes(item.id))
      .map((item) => item.offers)
      .concat(value.offers)
      .filter((item: number) => item > 1);
    
    const uniqLandingsOffersCount = uniq(landings);

    const currentOffersCount = uniqLandingsOffersCount[0] || 1;
    const offersCanBeDeleted: boolean = this.currentOffersCount > 1 && currentOffersCount > value.offers;
    const landingsCanBeDeleted: boolean = this.path.landings > 1 && uniqLandingsOffersCount.length > 1;

    if (offersCanBeDeleted || landingsCanBeDeleted) {
      const payload: FlowLandingConfirm = {
        item: value, 
        oldItem: this.oldValue
      };

      this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: {
          message: this.t('You are adding lander with different number of offers. Are you sure?'),
          onConfirm: () => this.handleConfirm(payload),
          onCancel: () => this.handleCancel(payload),
        }})


    } else if(value.offers > 1) {
      this.$emit('fix-landing-count', value, true);
    }
  }

  handleConfirm(payload: FlowLandingConfirm) {
    this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: {
      onConfirm: () => {
        const { item } = payload;
        this.$emit('fix-landing-count', item);
      },
    }})
  }

  handleCancel(payload: FlowLandingConfirm) {
    const { oldItem } = payload;

    this.$nextTick(() => {
      this.landing = oldItem;
    });
  }

  get landingPercentage() {
    if (this.totalWeight == 0) { 
      return 0;
    }

    return Math.round(this.landing.weight / this.totalWeight * 100);
  }
}
